// extracted by mini-css-extract-plugin
export default {"wrapper":"CollectionThumbnail_wrapper__nHwAl","row":"CollectionThumbnail_row__vLDlH"};